/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "attr.required",
    title: "Required",
    description: "Validates that the field value is not null, empty, or undefined.",
    type: "attribute",
    applyAttributeBeforeValidation: true,
    use: {
        namespace: "ua.switch"
    },
    tests: {
        validTrue: {
            must: true,
            run: function () {
                return validate({ title: "Title", required: true }, "hello");
            }
        },
        validFalse: {
            must: true,
            run: function () {
                return validate({ title: "Title", required: false }, null);
            }
        },
        missingAndRequired: {
            throw: "fields.attr.required.missing",
            run: function () {
                return validate({ title: "Title", required: true }, "");
            }
        }
    },
    errors: {
        missing: {
            title: "Required Field",
            description: "The field is required but missing a value.",
            template: "The field '${title}' is required but was not provided."
        }
    }
});

function validate(spec, value) {
    var isRequired = !!spec.required;

    if (!isRequired) return;

    if (
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "") ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === "object" && Object.keys(value).length === 0)
    ) {
        _.errors.missing.throw({ title: spec.title || "Unknown Field" });
    }
}
module.exports.validate = validate;
